import computeClassName from '../../../../../utils/computeClassName';

const constants = Object.freeze({
  CLASSNAME_BASE: 'inline-flex items-center justify-center rounded-full bg-cc-secondary border-cc-primary-contrast text-cc-body-medium text-cc-primary-contrast w-8 h-8 border-2 border-cc-secondary-contrast'
});
export default function UserInitials({userInitials, className}) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  return <span className={computedClassName}>{userInitials}</span>;
}
